export const putDocumentInCategory = (payload?: any) => ({
    type: "@saga/PUT_DOCUMENT_IN_CATEGORY",
    payload
});

